import React, { useCallback, useEffect, useRef, useState } from 'react';

import { useMobxStores } from '@stores/store';
import { has as _has, isEmpty as _isEmpty } from 'lodash';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import MediaSlide from '@organisms/media/MediaSlideWrapper';
import TopBanner from '@organisms/media/common/TopBanner';
import MediaDialog from '@molecules/modal/dialog/MediaDialog';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';

const Media = () => {
  const ref = useRef();
  const { settingStore, mediaStore } = useMobxStores();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const uidDivRef = useRef(null);
  let query = queryString.parse(location.search);
  const isDetail = _has(query, 'detail');

  const getInitialData = useCallback(async () => {
    let query = queryString.parse(location.search);

    if (query.detail) {
      await mediaStore.getDetailData(query.detail);
    }

    if (_isEmpty(mediaStore.detail.src)) {
      navigate('/' + i18n.language + '/media');
    } else {
      settingStore.setMediaDialogState(true);
    }

    mediaStore.setListQuery('mediaList', {
      lang: i18n.language,
      size: 200,
      page: 1,
    });

    setLoading(true);
    await mediaStore.getMediaList();
    await mediaStore.getMediaCategory();
    await mediaStore.getMainBanner();
    setLoading(false);
    return true;
  }, [mediaStore, i18n.language]);

  useEffect(() => {
    if (!loading) getInitialData();
  }, [mediaStore, getInitialData]);

  return (
    <>
      <section
        className={classnames('my-[44px] overflow-hidden', 'xl:my-[96px]')}
      >
        <div className={'container mx-auto'}>
          <div>
            {!_isEmpty(mediaStore.banner) && (
              <TopBanner banner={mediaStore.banner} />
            )}
          </div>

          <div className="mt-[20px]">
            {!_isEmpty(mediaStore.category) &&
              mediaStore.category.map((row, index) => (
                <MediaSlide
                  key={index}
                  category={row}
                  rows={
                    mediaStore.mediaMap.contents[mediaStore.category[index].idx]
                  }
                />
              ))}
          </div>
        </div>
      </section>
      {isDetail &&
        !_isEmpty(mediaStore.detail) &&
        !_isEmpty(mediaStore.detail.src) && (
          <MediaDialog
            src={mediaStore.detail.src}
            type={mediaStore.detail.type}
            title={mediaStore.detail.title}
          />
        )}
    </>
  );
};

export default observer(Media);
